import styled from "styled-components";

export const ContainerOtrosTramites = styled.div`
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  @media (min-width: 1000px) {
    display: none;
  }
`;

export const TextOtrosTramites = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 20%;
  .title-saludo {
    font-weight: 400;
    font-size: 24px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-pregunta {
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-negrita {
    font-weight: bold;
  }
`;

export const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  svg {
    width: 25px;
    height: 25px;
  }
`;


export const HeaderHomeBar = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  margin: auto;
  color: var(--color-white);
  background-color: var(--color-latex10);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 4px solid var(--color-primary);

  .title {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }
  .title-negrita {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }

  h1 {
    padding: 0;
    margin: 0;
    text-align: center;
  }
  .container-ellipse {
    width: 100%;
    height: max-content;
    /* background-color: red; */
    position: absolute;
    bottom: -50%;
    margin: auto;
    right: 0;
  }

  ::after {
    content: "";
    position: absolute;
    width: 150%;
    height: 50px;
    bottom: -25px;
    z-index: -1;
    border-radius: 50%;
    background-color: var(--color-latex10);
  }
`;